import { useState, useEffect } from 'react';
import 'react-tabs/style/react-tabs.css';
import 'moment/locale/pt-br';

import { Stack, Button } from '@mui/material';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';
import * as TabelaAPI from '../../../api/tabela';

import Input from '../../form/Input';
import InputNumber from '../../form/InputNumber';
import Checkbox from '../../form/Checkbox';
import SelectEmpresa from '../../form/SelectEmpresa';

/* utils */
import { formatarNumero, formatarNumeroDecimal } from '../../../utils/masks';

function Form({ handleSubmit, dados, setDados, btnText, caminhoVoltar, OptionsEmpresa }) {
    const navigate = useNavigateParams();
    const { setFlashMessage } = useFlashMessage();

    function handleChange(e) {
        const { name, value, type, checked } = e.target;
        if (name === 'fator' || name === 'fatorCorrecao') {
            const valorFormatado = formatarNumeroDecimal(value);
            setDados({
                ...dados,
                [name]: valorFormatado,
            });
        } else {
            setDados({ ...dados, [name]: type === 'checkbox' ? checked : value });
        }
    }

    async function handleOnBlur(e) {
        const { name, value, type, checked } = e.target;
        //verifica duplicidade
        if (name === 'descricao' && btnText === 'Cadastrar') {
            const duplicidade = await TabelaAPI.duplicidadeDescricao(dados.empresaId, 'Unidades', value);

            if (duplicidade?.uuid) {
                setFlashMessage('Registro em duplicidade!', 'warning');
                return navigate(`/Unidades/CreateOrEdit`, {
                    uuid: duplicidade.uuid,
                });
            }
        }
    }
    function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();

        handleSubmit(dados);
    };

    return (
        <form onSubmit={submit}>
            <h1>Unidades de medidas</h1>
            <div>
                <SelectEmpresa
                    text="Selecione a Empresa"
                    name="empresaId"
                    options={OptionsEmpresa}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.empresaId || ''}
                    notOptNull={true}
                    required
                />
                <Input
                    text="Descricao"
                    type="text"
                    name="descricao"
                    placeholder="nome do unidade"
                    title="Digite o nome do unidade de medida"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.descricao || ''}
                    required
                />
                <Input
                    text="Código"
                    type="text"
                    name="codigo"
                    placeholder="código da unidade"
                    title="Digite o código da unidade"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.codigo || ''}
                />
                <InputNumber
                    text="Fator"
                    type="text"
                    name="fator"
                    placeholder="Fator"
                    inputWidth="100px"
                    title="digite o fator da unidade"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.fator ? formatarNumero(dados.fator) : ''}
                />
                <InputNumber
                    text="Fator Correção"
                    type="text"
                    name="fatorCorrecao"
                    placeholder="Fator"
                    inputWidth="100px"
                    title="digite o fator de correção da unidade, exemplo de uso, conversão de litros para dividir por 1000"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.fatorCorrecao ? formatarNumero(dados.fatorCorrecao) : ''}
                />
            </div>
            <div>
                <Input
                    text="Título"
                    type="text"
                    name="titulo"
                    placeholder="titulos"
                    inputWidth="500px"
                    title="O título facilita em alguns processos, pois vai explicar ao usuário o funcionamento da rotina"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.titulo || ''}
                    min={1}
                />
            </div>
            <div>
                <Checkbox
                    title="Informa que precisa ser pesado no movimento"
                    text="Pesável"
                    name="pesavel"
                    handleOnChange={handleChange}
                    value={dados.pesavel}
                    checked={!!dados.pesavel}
                />
                <Checkbox
                    title="Informa que a uidade será utilizada nos movimentos de entrada"
                    text="Entrada"
                    name="entrada"
                    handleOnChange={handleChange}
                    value={dados.entrada}
                    checked={!!dados.entrada}
                />
                <Checkbox
                    title="Informa que a unidade será utilizada nos movimentos de saída"
                    text="Saída"
                    name="saida"
                    handleOnChange={handleChange}
                    value={dados.saida}
                    checked={!!dados.saida}
                />
                <Checkbox
                    title="Informa que a unidade será utilizada nos processos de industrialização"
                    text="Indústria"
                    name="industria"
                    handleOnChange={handleChange}
                    value={dados.industria}
                    checked={!!dados.industria}
                />
                <Checkbox
                    title="Informa que a unidade aceita fração "
                    text="Aceita Fração"
                    name="aceitaFracao"
                    handleOnChange={handleChange}
                    value={dados.aceitaFracao}
                    checked={!!dados.aceitaFracao}
                />
                <Checkbox
                    title="Quando marcado a forma de pagamento ou recebimento esta ATIVO"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </div>
            <div>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                        Voltar
                    </Button>
                    <Button type="submit" variant="contained" color="success">
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}
export default Form;
